import { defineComponent } from "vue/dist/vue.esm-bundler.js";

export const TaskHistoryPanel = defineComponent({
    name: "TaskHistoryPanel",
    props: {
        bridge: { type: Object, required: true },
        view: { type: Object, required: true }
    },
    template: `
        <div class="task-history-panel" :class="{ 'is-open': view.taskHistoryOpen }">
            <div class="task-history-header">
                <span class="task-history-title">最近のタスク</span>
                <button type="button" class="secondary" @click="bridge.refreshTaskHistory()">更新</button>
            </div>
            <div class="task-history-list">
                <div v-if="view.historyLoading" class="task-history-empty">履歴を読み込み中です。</div>
                <div v-else-if="!view.historyItems.length" class="task-history-empty">表示できる履歴がありません。右上の更新で取得できます。</div>
                <template v-else>
                    <button
                        v-for="item in view.historyItems"
                        :key="item.sessionId"
                        type="button"
                        class="task-history-item"
                        :class="{ 'is-active': item.isActive }"
                        @click="bridge.resumeHistory(item.sessionId)"
                    >
                        <div class="task-history-item-head">
                            <span class="task-history-item-goal" :title="item.goalFull || item.goal">{{ item.goal }}</span>
                            <span class="task-history-item-status">{{ item.jobStatus }}</span>
                        </div>
                        <div class="task-history-item-meta">
                            <span>{{ item.updatedLabel }}</span>
                            <span>{{ item.mode }}</span>
                            <span>{{ item.summary }}</span>
                        </div>
                    </button>
                </template>
            </div>
        </div>
    `
});
